import { produce } from 'immer';

import { LoadInternalMarketers } from '../../../actions/marketers/internal/loadInternalMarketers';
import { MarketersPageStates, MarketersState } from '../../../typings/marketers';

export function loadInternalMarketers(state: MarketersState, action: LoadInternalMarketers): MarketersState {
    return produce(state, draft => {
        draft.pageStatus = MarketersPageStates.LOADING;
    });
}
